import Kithara from "src/services/kithara";
const kithara = new Kithara();

export const namespaced = true;

export default {
  state: {
    list: [],
    current: {}
  },
  mutations: {
    SET_TAGS(state, tags) {
      state.list = tags;
    },
    ADD_TAG(state, tag) {
      state.list.push(tag);
    },
    SET_TAG(state, tag) {
      state.current = tag;
    }
  },
  actions: {
    createTag(commit, tag) {
      return kithara.postTag(tag).then(response => {
        commit("ADD_TAG", response.data.data);
      });
    },
    fetchTags({ commit }) {
      return kithara.getTags().then(response => {
        commit("SET_TAGS", response.data.data);
        return response.data.data;
      });
    },
    fetchTag(commit, id) {
      return kithara.getTag(id).then(response => {
        commit("SET_TAG", response.data.data);
        return response.data.data;
      });
    }
  },
  getters: {
    filterByName: state => name => {
      return state.list.filter(tag =>
        tag.name.toLowerCase().includes(name.toLowerCase())
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/tags.js